module.exports = __webpack_public_path__ + "static/media/logo-hp.c39c4021.svg";